import { Button } from '@/components/button'
import { T } from '@/components/t'
import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { SvgOutlinedPhone } from '@/icons/svg-outlined-phone'
import { COLORS } from '@/utils/styles/colors'

export const RestaurantDetailContact = () => {
    const { restaurant } = useRestaurantDetailContext()

    if (!restaurant) return null

    return (
        <div className="flex flex-col gap-y-4">
            <div className="flex items-center gap-2">
                <T h4 className="font-semibold" t="restaurants.detail.contact.phone" />

                <p className="font-medium">{restaurant.phone}</p>
            </div>

            <div className="md:hidden">
                <Button
                    href={{ externalUrl: `tel:${restaurant.phone}` }}
                    styleType="secondary"
                    className="gap-x-2"
                    shape="pill"
                >
                    <SvgOutlinedPhone size={20} color={COLORS.black} />

                    <T className="font-medium text-[15px]" t="restaurants.detail.contact.call" />
                </Button>
            </div>
        </div>
    )
}
